function handleOkVatNumberCheckInvoice() {
    $("#vatfreeorderFiscalCodeOk").css("display", "block");
    $(".vatfreeorderFiscalCodeNok").hide();
}

function handleNokVatNumberCheckInvoice() {
    $(".vatfreeorderFiscalCodeNok").show();
    $("#vatfreeorderFiscalCodeOk").css("display", "none");
}